/**
* League defines model for league object information
*
* @typedef LeagueInfo
* @type {Object}
* @property {id} LeagueId identifier
* @property {name} Name of current league ( translated )
* @property {sortId} SortId of current league
* @property {rankId} RankId of current league
* @property {countryName} CountryName for current league
* @property {masterLeagueId} MasterLeagueId identifier
* @property {urlCode} URLCode of current league
*/
var LeagueInfo = /** @class */ (function () {
    function LeagueInfo(leagueData) {
        this.id = leagueData.id;
        this.name = leagueData.name;
        this.sortId = leagueData.sortId;
        this.rankId = leagueData.rankId;
        this.countryName = leagueData.countryName;
        this.masterLeagueId = leagueData.masterLeagueId;
        this.urlCode = leagueData.urlCode;
    }
    return LeagueInfo;
}());
export { LeagueInfo };
//# sourceMappingURL=LeagueInfo.js.map